<div class="tooltip">
  ? <span class="tooltiptext"> {{ this.Skeleton.Label }} </span>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/s-tooltip/s-tooltip.component.html